<template>
  <div class="headPCActive">
    <div class="head-content">
        <div>
           <img  src="../../assets/images/logo.png" alt="" @click="goHome()" style="width:160px;height:60px;object_fit:contain"/>
        </div>
       <ul>
        <li
          v-for="(item, index) of topicList"
          :key="index"
          :class="{ active: index==curIndex }"
          @click="indexState(item,index)"
        >
          {{ $t(item.name) }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script >
import headerBase from "./header.base.js";
import { getArticleCategory } from "@/config/api.js";

export default {
  mixins: [headerBase],
  components: {},
  data() {
    return {
      topicList: [],
      searchValue: "",
      searchFocus: false,
      lang: "",
      language: [
        {
          label: "中文",
          value: "cn",
        },
        {
          label: "英文",
          value: "en",
        },
      ],
      dialogVisible: false,
      isActiveHeadPC: false,
      curIndex:0,
    };
  },
  watch: {},
  computed: {
    logo() {
      return ""
    },
  },
  methods: {
    indexState: function (item,index) {
      this.curIndex = index;
      //标题栏的
      if (item.slug) {
        this.$router.push({ path: "/" + item.slug ,  query: {
          type: item.id,
        },});
      } else {
        this.$router.push({
          path: "/index",
          query: {
          type: item.id,
        },
        });
      }
    },
    goHome(){
       this.$router.push({
          path: "/index",
        });
    },
    showIcon() {
      if (
        !!document.documentElement.scrollTop &&
        document.documentElement.scrollTop > 100
      ) {
        this.isActiveHeadPC = false;
      } else {
        this.isActiveHeadPC = true;
      }
    },
    changeIndex(index) {
      this.imgList[index].show = !this.imgList[index].show;
    },
    changeIndexBack(index) {
      this.imgList[index].show = !this.imgList[index].show;
    },
    requestArticleCategory() {
      getArticleCategory().then((res) => {
        console.log("getArticleCategory===", res.data);
        this.topicList = [{"id":0,name:"首页",slug:"index"}];
        if (res.data) {
          res.data.forEach(element => {
             this.topicList.push(element);
          });
         
        }
      });
    },
  },
  mounted() {
    this.requestArticleCategory();
    window.addEventListener("scroll", this.showIcon);
  },
};
</script>

<style lang="scss">
.headPC {
  height: 80px;
  background: #ffffff;
  line-height: 60px;
  position: relative;
  width: 100%;
  display: flex;
  position: fixed;
  z-index: 110;
}

.headPCActive {
  height: 60px;
  background: #ffffff;
  // background: rgba(71, 71, 71, 0.9);
  box-shadow: 0px 2px 7px 0px rgba(63, 63, 63, 0.15);
  line-height: 100px;
  width: 100%;
  // min-width: 1200px;
  display: flex;
  // position: absolute !important;
  position: fixed;
  z-index: 110;
  padding: 0 8%;
  .head-content {
    height: 100%;
    width: 100%;
    position: relative;
    padding: 0 0px 0 0px;
    img {
      width: 10%;
      height: 100%;
      padding: 8px;
      float: left;
      object-fit: contain;
      cursor: pointer;
    }
    .nav_github {
      float: right;
      text-align: center;
    }
    .nav_github_Img {
      z-index: 46;
      width: 40px;
      height: 40px;
      margin-top: 3px;
      padding: 5px 0;
      object-fit: contain;

      /* margin-left: 100px; */
    }
    .head_img {
      z-index: 46;
      width: 40px;
      height: 40px;
      margin-top: 0px;
      padding: 7px;
      object-fit: contain;

      /* margin-left: 100px; */
    }
    .nav_github_Img4:hover img {
      content: url(../../assets/images/crazy/header_link1_s.png);
    }

    ul {
      height: 60px;
      width: 100%;
      text-align: end;
      line-height: 60px;
      position: relative;
      z-index: 10;
      li {
        width: auto;
        display: inline-block;
        margin: 0 0% 0 4%;
        font-size: 15px;
        height: 60px;
        line-height: 60px;
        border-radius: 2px;
        text-align: right;
        cursor: pointer;
        font-family: Arial-BoldMT;
        font-family: ArialMT;
        // border-radius: 15px 0px 15px 0px;
        padding: 0px 10px;
        color: #1f1f22;
        font-weight: 500;
      }

      .active {
        color: rgb(243, 17, 17);
        border-bottom: 2px solid rgb(243, 17, 17);
        //background: #ff795d;
        // font-weight: 600;
        // font-size: 17px;
      }
    }
  }
}

.setting-in-pc {
  height: 75px;
  line-height: 75px;
  margin-left: 12px;
}
</style>
